module.exports = __webpack_public_path__ + "1add4d9f80dce3b5561188c71ab04044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_65.jpg
// module id = 1719
// module chunks = 5